import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

function BomTypeTab() {
  const { t } = useTranslation('common');
  const history = useHistory();

  const handleNavigate = (path) => {
    history.push(path);
  };

  return (
    <div>
      <div className="d-flex justify-content-end my-3">
        <Button
          className={`btn btn-page-filter ${history.location.pathname === '/libraries/bom-type' ? 'btn-active' : ''}`}
          onClick={() => handleNavigate('/libraries/bom-type')}
        >
          {t('BOM_TYPE.BOM_TYPE_GROUP.BOM_TYPE_GROUPS.BOM_TYPE_LIBRARY')}
        </Button>
        <Button
          className={`btn btn-page-filter ${history.location.pathname === '/libraries/bom-type-group' ? 'btn-active' : ''}`}
          onClick={() => handleNavigate('/libraries/bom-type-group')}
        >
          {t('BOM_TYPE.BOM_TYPE_GROUP.BOM_TYPE_GROUPS.BOM_TYPE_GROUPS')}
        </Button>
      </div>
    </div>
  );
}

export default BomTypeTab;
